var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.327 5.08485L10.4002 0.125533H10.4033C10.1027 -0.0418442 9.74004 -0.0418442 9.43938 0.125533L0.509509 5.09105C0.0321742 5.35761 -0.141402 5.96203 0.125161 6.43936C0.391725 6.9167 0.996142 7.09028 1.47348 6.82371L9.91981 2.13096L18.3662 6.82061C18.8435 7.08718 19.4479 6.9136 19.7145 6.43626C19.9779 5.95893 19.8075 5.35451 19.327 5.08485ZM12.5268 11.5473C13.966 10.1081 13.966 7.77469 12.5268 6.33546C11.0876 4.89624 8.75415 4.89624 7.31493 6.33546C5.8757 7.77469 5.8757 10.1081 7.31493 11.5473C8.75415 12.9866 11.0876 12.9866 12.5268 11.5473ZM8.60474 14.0078H11.2363C14.0724 14.0078 16.3723 16.3077 16.3723 19.1438C16.3723 19.6149 15.9879 19.9993 15.5168 19.9993H4.32423C3.8531 19.9993 3.46875 19.6149 3.46875 19.1438C3.46875 16.3077 5.76863 14.0078 8.60474 14.0078Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.77e43b7b51ac2c913a8e9f9c45223f8e.svg";
export { ForwardRef as ReactComponent };